module.exports = __webpack_public_path__ + "img/csv.3df71908.svg";